import { render, staticRenderFns } from "./LotHistory.vue?vue&type=template&id=9c087b26&scoped=true&"
import script from "./LotHistory.script.js?vue&type=script&lang=js&"
export * from "./LotHistory.script.js?vue&type=script&lang=js&"
import style0 from "./LotHistory.scss?vue&type=style&index=0&id=9c087b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c087b26",
  null
  
)

export default component.exports